export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9149.c03b4651.jpg";